import filterAPI from "../api/filterAPI";

export function fetchMapsData() {
  return (dispatch) => {
    filterAPI
      .getMapDetialsScreen1()
      .then((res) => {
        let mapsData = res.data.data;
        dispatch(handleMapsData(mapsData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function fetchRegionsData() {
  return (dispatch) => {
    filterAPI
      .getRegionsData()
      .then((res) => {
        let regionsData = res.data.data;
        dispatch(handleRegionsData(regionsData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function fetchScoresData(region_name) {
  return (dispatch) => {
    filterAPI
      .getScoresDataScreen1({"region_name": region_name })
      .then((res) => {
        let scoresData = res.data.data;
        dispatch(handleScoresData(scoresData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function fetchOutcomeData(region_name) {
  return (dispatch) => {
    filterAPI
      .getOutcomeDataScreen1({"region_name": region_name })
      .then((res) => {
        let outcomeData = res.data.data;
        let outcomeToolBarData = res.data.toolBarData;
        dispatch(handleOutcomeData(outcomeData, outcomeToolBarData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function fetchDemographicsData(region_name) {
  return (dispatch) => {
    filterAPI
      .getDemographicDataScreen1({"region_name": region_name })
      .then((res) => {
        let raceData = res.data.race_data;
        let ageData = res.data.age_data;
        dispatch(handleDemographicsData(raceData, ageData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function updateSelectedRegion(region_name) {
  return (dispatch) => {
    dispatch(setSelectedRegion(region_name));
  };
}

function setSelectedRegion(data) {
  return {
    type: "SET_SELECTED_REGION",
    payload: data,
  };
}

function handleMapsData(data) {
  return {
    type: "GET_MAPS_DATA",
    payload: data,
  };
}

function handleRegionsData(data) {
  return {
    type: "GET_REGIONS_DATA",
    payload: data,
  };
}

function handleScoresData(data) {
  return {
    type: "GET_SCORES_DATA",
    payload: data,
  };
}

function handleOutcomeData(data, toolBarData) {
  return {
    type: "GET_OUTCOME_DATA",
    payload: [data, toolBarData],
  };
}

function handleDemographicsData(race_data, age_data) {
  return {
    type: "GET_DEMOGRAPHIC_DATA",
    payload: [race_data, age_data],
  };
}
